import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import DatePicker from '@src/main/shared/ui/components/calendar/DatePicker';
import { FC } from 'react';
import { Control, Controller, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface DateRangeFieldsProps {
  styles: Record<string, string>;
  control: Control<NewMessageFormData>;
  watch: UseFormWatch<NewMessageFormData>;
}

export const DateRangeFields: FC<DateRangeFieldsProps> = ({ styles, control, watch }) => {
  const { t } = useTranslation();
  const startDateValue = watch('initDate');
  const minDate = startDateValue ? new Date(startDateValue) : undefined;

  return (
    <div className={styles['form-row']}>
      <div className={styles['form-section']}>
        <label>{t('messages.mailbox.newMessage.initDate')}</label>
        <Controller
          name="initDate"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <DatePicker
                value={field.value ? new Date(field.value) : null}
                onChange={field.onChange}
                showTime
                hourFormat="24"
              />
              {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
            </>
          )}
        />
      </div>

      <div className={styles['form-section']}>
        <label>{t('messages.mailbox.newMessage.endDate')}</label>
        <Controller
          name="endDate"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <DatePicker
                value={field.value ? new Date(field.value) : null}
                onChange={field.onChange}
                showTime
                hourFormat="24"
                minDate={minDate}
              />
              {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
            </>
          )}
        />
      </div>
    </div>
  );
};
